import React, { Component } from 'react';
import { isEmpty } from '../../Common/Common';

import Top_Bar from '../../Part_Sample/Top_Bar';
import Collapsible_Point_Selection from '../util/Collapsible_Point_Selection';
import { getTrendChartCategory } from '../util/util';

import down_icon from '../../../Images/Daikin_Images/image/down.png';
import up_icon from '../../../Images/Daikin_Images/image/up.png';

export default class Trend_Data_Select_Points extends Component {
	constructor(props) {
		super(props);
		let selected_points = [];
		let selected_categories = [];

		if (this.props.param.points != null) {
			// Eg. this.props.param.points = [["dummy:1-00006","non"],["dtatcp1:1-00001","sp"],["dtatcp1:1-00001","temp"],...]
			// Extract only the point_id to get the selected_points
			for (let point of this.props.param.points) {
				let point_id = point[0];
				if (!selected_points.includes(point_id)) {
					selected_points.push(point_id);
					let category_name = getTrendChartCategory(point_id);
					if (!selected_categories.includes(category_name)) selected_categories.push(getTrendChartCategory(point_id));
				}
			}
		}

		// At first, create a list selectable points
		let display_selectable_points = {};

		for (let row of this.props.param.available_points) {
			let point_id = row[0];
			let point_info = window.app.state.point_list[point_id];

			if (!isEmpty(point_info)) {
				if (point_info.type == 'Ac' || (point_info.type == 'Value' && point_info.unit == 'DEG' && point_info.usage == 'temp')) {
					if (isEmpty(display_selectable_points.temp)) {
						display_selectable_points.temp = {};
						display_selectable_points.temp.is_show_points = false;
						display_selectable_points.temp.points = {};
					}
					display_selectable_points.temp.points[point_id] = point_info;
				} else {
					let category = getTrendChartCategory(point_id);
					if (category != '') {
						if (isEmpty(display_selectable_points[category])) {
							display_selectable_points[category] = {};
							display_selectable_points[category].is_show_points = false;
							display_selectable_points[category].points = {};
						}
						display_selectable_points[category].points[point_id] = point_info;
					}
				}
			}
		}
		this.state = {
			display_selectable_points: display_selectable_points,
			selected_points: selected_points,
			selected_categories: selected_categories,
		}
	}

	handlePrevious = () => {
		// Go back to previous screen
		let param = this.props.param;
		let from = param.from;
		param.from = this.props.param.original_from;
		delete param.original_from;

		//window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler(from, param);
	}

	handleShowPoints = (category_name) => {
		let display_selectable_points = JSON.parse(JSON.stringify(this.state.display_selectable_points));
		display_selectable_points[category_name].is_show_points = !display_selectable_points[category_name].is_show_points;
		this.setState({ display_selectable_points: display_selectable_points })
	}

	handleSelectPoint = (point_id) => {
		let selected_points = [...this.state.selected_points];
		let selected_categories = [...this.state.selected_categories];
		let new_selected_categories = [];

		if (!selected_points.includes(point_id)) {
			selected_points.push(point_id);
			new_selected_categories = selected_categories;
			let category_name = getTrendChartCategory(point_id);
			if (!new_selected_categories.includes(category_name)) new_selected_categories.push(category_name)
		} else {
			selected_points.splice(selected_points.indexOf(point_id), 1);
			// Repopulate the selected categories
			for (let selected_point_id of selected_points) {
				let category_name = getTrendChartCategory(selected_point_id);
				if (!new_selected_categories.includes(category_name)) new_selected_categories.push(category_name);
			}
		}

		if (new_selected_categories.length > 2) {
			window.app.showToast(this.props.receiver.getString('more_than_2_cat'), 3000);
			return;
		}

		this.setState({
			selected_points: selected_points,
			selected_categories: new_selected_categories,
		})
	}

	handleRegister = () => {
		window.app.showLoading();
		this.param = this.props.param;
		let points = [];

		for (let point_id of this.state.selected_points) {
			let point_info = window.app.state.point_list[point_id];
			if (point_info.type == 'Ac') {
				let point = [];
				if (point_info.store_sp) {
					point = [point_id, 'sp'];
					points.push(point);
				}
				if (point_info.store_temp) {
					point = [point_id, 'temp'];
					points.push(point);
				}
				if (point_info.store_otemp) {
					point = [point_id, 'otemp'];
					points.push(point);
				}
			} else {
				points.push([point_id, 'non']);
			}
		}

		this.param.points = points;

		let search_details = {
			fy: this.param.search_start_date.getFullYear(),
			fm: this.param.search_start_date.getMonth() + 1,
			fd: this.param.search_start_date.getDate(),
			fh: this.param.search_start_date.getHours(),
			fmin: 0,
			ty: this.param.search_end_date.getFullYear(),
			tm: this.param.search_end_date.getMonth() + 1,
			td: this.param.search_end_date.getDate(),
			th: this.param.search_end_date.getHours(),
			tmin: 0,
			points: points
		}

		this.props.receiver.getTrend(search_details);
	}

	rcvTrendData = (trend_data) => {
		window.app.hideLoading();
		this.param.trend_data = trend_data;
		let from = this.param.from;
		this.param.from = this.props.param.original_from;
		delete this.param.original_from;

		//window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler(from, this.param);
	}

	render() {
		// Determine device orientation
		let screen_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		let screen_height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
		let is_landscape = screen_width > screen_height;

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let card_style = {
			background: 'white',
			borderRadius: 20,
			padding: 10,
			width: this.props.width - 60,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: 10,
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('select_devices')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ marginTop: 10, marginLeft: 20, textAlign: 'left' }}>
						<span className='subtitle' style={{ fontSize: 14 }}>{this.props.receiver.getString('more_than_2_cat')}</span>
					</div>

					<div style={{ height: this.props.height - 175, overflow: 'auto', width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', marginTop: 10, }}>
						{Object.keys(this.state.display_selectable_points).map((category_name) => {
							let category = this.state.display_selectable_points[category_name];
							let category_selected_points = [];
							let category_points_id = Object.keys(category.points);
							for (let point_id of this.state.selected_points) {
								if (category_points_id.includes(point_id)) category_selected_points.push(point_id)
							}

							let is_disabled = false;
							if (this.state.selected_categories.length > 1 && !this.state.selected_categories.includes(category_name)) {
								is_disabled = true;
							}

							return (
								<div style={card_style}>
									<div style={{ cursor: 'pointer', width: '100%', textAlign: 'left' }} onClick={() => this.handleShowPoints(category_name)}>
										<span style={{ fontSize: 24, display: 'inline-block', width: '90%' }}>{this.props.receiver.getString(category_name)}</span>
										<img src={category.is_show_points ? up_icon : down_icon} style={{ width: 20, height: 20 }} />
									</div>
									<Collapsible_Point_Selection
										is_show={category.is_show_points}
										is_disabled={is_disabled}
										max_height={is_landscape ? this.props.height : this.props.height - 470}
										width={this.props.width - 20}
										points_selection={category.points}
										handleTogglePoints={(point_id) => this.handleSelectPoint(point_id)}
										selected_points={category_selected_points}
										disabled_points={[]}
									/>
								</div>
							)
						})}
					</div>
				</div>
			</div>
		)
	}
}